export function isCloudRecordingType(recType: string): boolean {
  return recType === 'cloud' || recType === 'cloud-beta';
}
